import React from 'react';

import styles from './styles.module.css';

const InfoLinks = () => (
  <>
    <h2 className={styles['inquiries-h2']}>Customer Service Inquiries</h2>
    To reach customer service, please
    {' '}
    <a className={styles['inquiries-a']} href="https://fabfitfun.com/concierge/">click here</a>
    <p>&nbsp;</p>
    <h2 className={styles['inquiries-h2']}>Diverse Supplier Inquiries</h2>
    FabFitFun is looking to continue to diversify its supplier base for both our
    e-commerce and subscription box platforms.
    Diverse Suppliers, please
    {' '}
    <a className={styles['inquiries-a']} href="https://fabfitfun.com/supplier-diversity/">click here</a>
    <p>&nbsp;</p>
    <h2 className={styles['inquiries-h2']}>Press and Media</h2>
    For media inquiries, please contact
    {' '}
    <a
      className={styles['inquiries-a']}
      href="mailto:Press@fabfitfun.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      press@fabfitfun.com
    </a>
    <p>&nbsp;</p>
    <h2 className={styles['inquiries-h2']}>Marketing and Advertising</h2>
    Have a marketing opportunity?
    {' '}
    <a
      className={styles['inquiries-a']}
      href="mailto:marketing@fabfitfun.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      Email us!
    </a>
    <br />
    Are you an influencer and want to be our partner?
    {' '}
    <a
      className={styles['inquiries-a']}
      href="mailto:collab@fabfitfun.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      Email us!
    </a>
    <br />
    Want to partner, sponsor an event, or advertise with FabFitFun?
    {' '}
    <a
      className={styles['inquiries-a']}
      href="mailto:advertise@fabfitfun.com"
      rel="noopener noreferrer"
      target="_blank"
    >
      Email us!
    </a>
    <p>&nbsp;</p>
  </>
);

export default InfoLinks;
